import React, { memo } from 'react';
import { CMS_ELEMENT_TYPENAME } from '@repo/utils/constants';
import { TYPES as COMMON_TYPES } from '@repo/ui/lib';
import { GROUP_TYPES } from '@/lib';
import dynamicWithLoader from '@repo/ui/src/components/common/DynamicWithLoader';
import VideoBanner from '@repo/ui/src/components/Banners/VideoBanner';
import TextModules from '@repo/ui/src/components/textModules/TextModules'; // jeżeli jest import dynamiczny to jest bug ze zmianą tła

const DynamicDescriptionSlogan = dynamicWithLoader(() => import('@repo/ui/src/components/common/DescriptionSlogan'));
const DynamicAboutTeamDigital = dynamicWithLoader(() => import('@/components/AboutTeam'));
const DynamicAllNewsPresentation = dynamicWithLoader(() => import('@/components/allNewsPresentation/AllNewsPresentation'));
const DynamicSingleAsset = dynamicWithLoader(() => import('@repo/ui/src/components/common/SingleAsset'));
const DynamicAssetWithHeaderAndDescription = dynamicWithLoader(
	() => import('@repo/ui/src/components/common/AssetWithHeaderAndDescription'),
);
const DynamicHeaderAndDescription = dynamicWithLoader(() => import('@repo/ui/src/components/common/HeaderAndDescription'));
const DynamicStyledGallery = dynamicWithLoader(() => import('@repo/ui/src/components/common/StyledGallery'));
const DynamicProjectRange = dynamicWithLoader(() => import('@repo/ui/src/components/projectRange/ProjectRange'));
const DynamicProjectScope = dynamicWithLoader(() => import('@repo/ui/src/components/projectScope/ProjectScope'));
const DynamicProjectTechnologiesTable = dynamicWithLoader(
	() => import('@repo/ui/src/components/common/projectTechnologiesTable/ProjectTechnologiesTable'),
);
const DynamicPinnedTextWithImage = dynamicWithLoader(() => import('@repo/ui/src/components/PinnedTextWithImage/PinnedTextWithImage'));
const DynamicProjectSlider = dynamicWithLoader(() => import('@repo/ui/src/components/projectSlider/ProjectSlider'));
const DynamicContactForm = dynamicWithLoader(() => import('@repo/ui/src/components/ContactForm'));
const DynamicCheckOthers = dynamicWithLoader(() => import('@repo/ui/src/components/CheckOthers'));
const DynamicPleoContext = dynamicWithLoader(() => import('@repo/ui/src/components/PleoContext'));
const DynamicPleoBranches = dynamicWithLoader(() => import('@repo/ui/src/components/PleoBranches'));
const DynamicWhoWeWorkedWith = dynamicWithLoader(() => import('@repo/ui/src/components/WhoWeWorkedWith'));
const DynamicHorizontalHeaderModule = dynamicWithLoader(() => import('@repo/ui/src/components/common/HorizontalHeaderModule'));
const DynamicQuickContact = dynamicWithLoader(() => import('@repo/ui/src/components/QuickContact/QuickContact'));
const DynamicDescriptionLinePleo = dynamicWithLoader(() => import('@repo/ui/src/components/DescriptionLinePleo'));
const DynamicBlobSlogan = dynamicWithLoader(() => import('@repo/ui/src/components/BlobSlogan/index'));
const DynamicFeaturedProjects = dynamicWithLoader(() => import('@repo/ui/src/components/FeaturedProjects'));
const DynamicNewsThumbnails = dynamicWithLoader(() => import('@repo/ui/src/components/newsThumbnails/NewsThumbnails'));
const DynamicHowWeCreateStory = dynamicWithLoader(() => import('@repo/ui/src/components/HowWeCreateStory'));
const DynamicSocialMedia = dynamicWithLoader(() => import('@repo/ui/src/components/SocialMedia/SocialMedia'));
const DynamicFAQ = dynamicWithLoader(() => import('@repo/ui/src/components/FAQ/FAQ'));
const DynamicStoryModule = dynamicWithLoader(() => import('@repo/ui/src/components/Story'));
const DynamicHeaderDescriptionButtonBanner = dynamicWithLoader(
	() => import('@repo/ui/src/components/Banners/HeaderDescriptionButtonBanner'),
);

const Component = ({ item, typename, index, locale, allArticles, isCurrentPageGroup, storyData }) => {
	switch (typename) {
		case COMMON_TYPES.VIDEO_BANNER:
			return <VideoBanner data={item} locale={locale} webGL />;
		case COMMON_TYPES.SINGLE_ASSET:
			return <DynamicSingleAsset data={item} />;
		case COMMON_TYPES.ASSET_WITH_HEADER:
			return <DynamicAssetWithHeaderAndDescription data={item} />;
		case COMMON_TYPES.HEADER_AND_DESCRIPTION:
			return <DynamicHeaderAndDescription id={item} data={item} />;
		case COMMON_TYPES.ASSETS_GALLERY:
			return <DynamicStyledGallery data={item} />;
		case COMMON_TYPES.PROJECT_RANGE:
			return <DynamicProjectRange data={item} locale={locale} />;
		case COMMON_TYPES.PROJECT_SCOPE:
			return <DynamicProjectScope data={item} locale={locale} />;
		case COMMON_TYPES.TEXT_MODULE:
			return <TextModules key={item.id || index} data={item} locale={locale} />;
		case COMMON_TYPES.PINNED_TEXT_WITH_IMAGE:
			return <DynamicPinnedTextWithImage data={item} locale={locale} />;
		case COMMON_TYPES.PROJECT_SLIDER:
			return <DynamicProjectSlider data={item} locale={locale} />;
		case COMMON_TYPES.TECHNOLOGIES_TABLE:
			return <DynamicProjectTechnologiesTable data={item} locale={locale} />;
		case COMMON_TYPES.FORM:
			return <DynamicContactForm data={item} locale={locale} />;
		case COMMON_TYPES.DESCRIPTION_SLOGAN:
			return <DynamicDescriptionSlogan data={item} />;
		case COMMON_TYPES.ABOUT_TEAM:
			return <DynamicAboutTeamDigital data={item} isGroup />;
		case COMMON_TYPES.FAQ:
			return <DynamicFAQ data={item} />;
		case COMMON_TYPES.SOCIAL_MEDIA:
			return <DynamicSocialMedia data={item} />;
		case COMMON_TYPES.CHECK_OTHERS:
			return <DynamicCheckOthers data={item} />;
		case COMMON_TYPES.PLEO_CONTEXT:
			return <DynamicPleoContext data={item} />;
		case COMMON_TYPES.PLEO_BRANCHES:
			return <DynamicPleoBranches data={item} />;
		case COMMON_TYPES.WHO_WE_WORKED_WITH:
			return <DynamicWhoWeWorkedWith data={item} />;
		case COMMON_TYPES.HORIZONTAL_HEADER:
			return <DynamicHorizontalHeaderModule key={item?.id} data={item} />;
		case COMMON_TYPES.QUICK_CONTACT:
			return <DynamicQuickContact data={item} />;
		case COMMON_TYPES.DESCRIPTION_LOGO_PLEO:
			return <DynamicDescriptionLinePleo data={item} />;
		case COMMON_TYPES.COMMON_BLOB_SLOGAN:
			return <DynamicBlobSlogan data={item} />;
		case COMMON_TYPES.FEATURED_PROJECTS:
			return <DynamicFeaturedProjects data={item} type="group" />;
		case COMMON_TYPES.NEWS_THUMBNAILS:
			return <DynamicNewsThumbnails data={item} isCurrentPageGroup={isCurrentPageGroup} />;
		case COMMON_TYPES.HOW_WE_CREATE_STORY:
			return <DynamicHowWeCreateStory data={item} />;
		case GROUP_TYPES.ALL_NEWS_PRESENTATION:
			return <DynamicAllNewsPresentation data={item} allArticles={allArticles} />;
		case COMMON_TYPES.HEADER_DESCRIPTION_BUTTON_BANNER_RECORD:
			return <DynamicHeaderDescriptionButtonBanner data={item} type="group" />;
		case COMMON_TYPES.STORY_MODULE:
			return <DynamicStoryModule data={item} items={storyData} />;
		default:
			return null;
	}
};

const ExtendedContent = ({ content, locale, allArticles, isCurrentPageGroup, storyData }) => {
	if (Array.isArray(content)) {
		return content.map((item, index) => (
			<Component
				key={item?.id || index}
				item={item}
				typename={item[CMS_ELEMENT_TYPENAME]}
				index={index}
				locale={locale}
				allArticles={allArticles}
				isCurrentPageGroup={isCurrentPageGroup}
				storyData={storyData}
			/>
		));
	}
	return null;
};
export default memo(ExtendedContent);
